import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { companyInfo } from '../data/mockData';
import { Target, Users, Award, Lightbulb } from 'lucide-react';

const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: 'Mission',
      description: 'To deliver innovative technology solutions that transform businesses and drive sustainable growth.',
    },
    {
      icon: Users,
      title: 'Client-Centric',
      description: 'We put our clients at the center of everything we do, ensuring their success is our success.',
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'We strive for excellence in every project, delivering quality that exceeds expectations.',
    },
    {
      icon: Lightbulb,
      title: 'Innovation',
      description: 'We embrace innovation and continuously evolve to stay ahead of industry trends.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-orange-100 via-blue-50 to-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-0.5 bg-orange-500" />
              <span className="text-gray-600 font-medium tracking-wide">About Us</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
              Who We Are
            </h1>
            <p className="text-gray-700 text-lg leading-relaxed">
              {companyInfo.description}
            </p>
          </div>
        </div>
      </section>

      {/* Why Sanisolutions Section */}
      <section id="why-sanisolutions" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Why Sanisolutions?</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We combine decades of experience with cutting-edge technology to deliver solutions that matter.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="p-8 bg-gradient-to-br from-slate-50 to-white border border-gray-100 rounded-2xl hover:shadow-xl transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-orange-500 transition-colors">
                  <value.icon className="w-7 h-7 text-orange-500 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{value.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { number: '15+', label: 'Years Experience' },
              { number: '500+', label: 'Projects Delivered' },
              { number: '100+', label: 'Happy Clients' },
              { number: '50+', label: 'Team Members' },
            ].map((stat, index) => (
              <div key={index}>
                <div className="text-4xl md:text-5xl font-bold text-orange-500 mb-2">{stat.number}</div>
                <div className="text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
